import { useQuery } from "react-query";
import { getConfig } from "@jti/fe-common";
import { AvpAPI } from "../../services";
export const useAvpAvailableMethods = () => {
    var _a;
    const { data: availableMethods, isLoading: isAvailableMethodsLoading } = useQuery("callGetAvailableMethods", () => {
        return new AvpAPI(getConfig().AVP_URL).getAvailableMethods();
    }, {
        staleTime: Infinity,
        cacheTime: Infinity,
    });
    return {
        availableMethods: (_a = availableMethods === null || availableMethods === void 0 ? void 0 : availableMethods.data) !== null && _a !== void 0 ? _a : [],
        isAvailableMethodsLoading,
    };
};
//# sourceMappingURL=useAvpAvailableMethods.js.map